export default __webpack_public_path__ + "static/media/manual17.baac41a7.png";